module.exports = __webpack_public_path__ + "img/site.3a14fad8.png";